import React, { useEffect, useState } from "react";
import { Table, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./EmployeeOverview.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const EmployeeOverview = () => {
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [payAccordionOpen, setPayAccordionOpen] = useState(true);

  const [employee, setEmployee] = useState([]);
  const [links, setLinks] = useState([]);
  const [totalrec, setTotalrec] = useState(0);

  const [perpage, setPerpage] = useState(10);
  const [keyword, setKeyword] = useState('');

  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    document.title = `Customer-Overview | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', 10);
    formData.append('page', 1);
    API.post('backoffice_get_all_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployee(response.data.data.payment_history.data);
          setLinks(response.data.data.payment_history.links);
          setTotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setPerpage(perpage);

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', 1);

    API.post('backoffice_get_all_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployee(response.data.data.payment_history.data);
          setLinks(response.data.data.payment_history.links);
          setTotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handlePageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', page);
    API.post('backoffice_get_all_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployee(response.data.data.payment_history.data);
          setLinks(response.data.data.payment_history.links);
          setTotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleInputChangeauto = (event) => {
    var keyword = event.target.value;
    setKeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_get_all_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployee(response.data.data.payment_history.data);
          setLinks(response.data.data.payment_history.links);
          setTotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleSort = () => {
    setLoading(true);
    var ascdesc = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keyword);
    API.post('backoffice_get_all_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployee(response.data.data.payment_history.data);
          setLinks(response.data.data.payment_history.links);
          setTotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12 holisti okhas">
                    <h1 className="d-none d-md-block">Employee Information</h1>

                    <Card>
                      <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 justify-content-end">
                        <div className="d-flex align-items-center justify-content-md-start w-md-auto">
                          <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                            <div className="input-group">
                              <div className="input-group-text border-end-0">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                                  alt="Search Icon"
                                  className="img-fluid"
                                />
                              </div>
                              <input
                                type="text"
                                className="form-control border-start-0 ps-0"
                                placeholder="Search"
                                value={keyword}
                                onChange={handleInputChangeauto}
                              />
                            </div>
                          </div>
                          <button type="button" className="sloti" onClick={handleSort}>
                            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                            Sort {sortOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                          </button>
                        </div>
                      </div>
                      <div className="table-ro mt-2 d-none d-md-block">
                        <Table
                          responsive
                          className="table-no-last-border mb-0"
                        >
                          <thead className="table">
                            <tr className="custom-header">
                              <th className="lft">Join Date</th>
                              <th>ID #</th>
                              <th>Name</th>
                              <th>Phone #</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            {employee.map((item, index) => (
                              <tr key={index}>
                                <td className="lef">{item.join_date}</td>
                                <td>{item.customers_id}</td>

                                <td><img src={item.image} alt={item.name} className="ppt1 me-2" /><Link to={process.env.REACT_APP_BASE_URL + "dashboard-sales-vp-of-sales/" + item.id}>{item.name}</Link></td>
                                <td>{item.phone}</td>
                                <td>{item.email}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                        onClick={() => isMobile && setPayAccordionOpen(!payAccordionOpen)}
                        style={{ cursor: isMobile ? "pointer" : "default" }}
                      >
                        <h5>Employee Information</h5>
                        {isMobile && (
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              (payAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                            }
                            alt="Toggle Arrow"
                          />
                        )}
                      </div>
                      {(!isMobile || payAccordionOpen) && (
                        <>
                          <div className="d-md-none ev-mobilex oko">
                            {employee.map((item, index) => (
                              <div
                                key={index}
                                className="col-12 mb-3 main"
                              >
                                <div className="d-flex justify-content-between align-items-center fir mb-2">
                                  <div className="joily d-flex"><div className="date">{item.join_date}</div></div>
                                  <div>{/*<img src={process.env.REACT_APP_BASE_URL + 'assests/images/visa.png'} alt={item.name} className="img-fluid"/>*/} {item.payment_setup}</div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-2 gap-2">
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={item.image}
                                      alt={item.name}
                                      className="ppt1"
                                    />
                                    <div className="ms-2 fgtrx">
                                      <Link to={process.env.REACT_APP_BASE_URL + "dashboard-sales-vp-of-sales/" + item.id}>{item.name}</Link>
                                      <div className="joily d-flex">ID #{item.customers_id}</div>
                                    </div>
                                  </div>
                                  <div className="kayde kayoode"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/prifile.png'} alt={item.name} className="me-1" />{item.name}</div>
                                </div>
                                <div className="erroo d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/emiyy.png'} alt={item.name} className="me-2" />{item.email}</div>
                                <div className="phony d-flex align-items-center mb-2"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/phonty.png'} alt={item.name} className="me-2" />{item.phone}</div>
                              </div>
                            ))}
                          </div>
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                            <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                              <label>Show rows:</label>
                              <select
                                value={perpage}
                                onChange={handleRowsChange}
                                className="form-select w-auto"
                              >
                                <option value={10}>10 items</option>
                                <option value={15}>15 items</option>
                                <option value={20}>20 items</option>
                                <option value={25}>25 items</option>
                              </select>
                            </div>
                            {totalrec > 0 && (
                              <nav>
                                <ul className="pagination pagination-sm mb-0 flex-wrap">

                                  {links.map((link, index) => {
                                    var label = link.label;
                                    if (label.includes("Previous")) label = "<";
                                    if (label.includes("Next")) label = ">";

                                    return (
                                      <>
                                        <li className={`page-item ${link.active ? "active" : ""}`}>
                                          <button
                                            className={`page-link ${!link.url ? "disabled" : ""}`}
                                            onClick={() => {
                                              if (link.url) {
                                                const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                                handlePageChange(pageNumber);
                                              }
                                            }}
                                          >
                                            {label}
                                          </button>
                                        </li>
                                      </>
                                    );
                                  })}
                                </ul>
                              </nav>
                            )}
                          </div>
                        </>
                      )}
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};
export default EmployeeOverview;